<template>
  <el-card class="profile-container">
    <el-form size="small">
      <el-form-item label="用户名：">
        <el-input disabled v-model="user_info.username" />
      </el-form-item>
      <el-form-item label="系统角色：">
        <el-input disabled v-model="role_name" />
      </el-form-item>
      <el-form-item label="密码：">
        <el-button @click="passWordDialogVisible = true">修改密码</el-button>
      </el-form-item>
      <!-- <el-form-item label="视频与公司：">
        <el-button @click="changePassWord()">{{!is_open?'禁用':'启用'}}</el-button>
      </el-form-item> -->
      <!-- <el-form-item label="支付密码：">
        <el-button @click="payPasswordDialogVisible = true">修改密码</el-button>
      </el-form-item> -->
      <el-form-item label="真实姓名：">
        <el-input disabled v-model="user_info.realname" />
      </el-form-item>
      <el-form-item label="手机号：">
        <el-input disabled v-model="user_info.mobile" />
      </el-form-item>
      <el-form-item label="Email：">
        <el-input disabled v-model="user_info.email" />
      </el-form-item>
    </el-form>

    <el-button size="medium" @click="close">关闭</el-button>

    <PasswordDialog :visible.sync="passWordDialogVisible" />
  </el-card>
</template>

<script>
import PasswordDialog from "./password";
import { getInfo, getRoleList } from "@/api/user";

export default {
  name: "ProfileIndex",
  components: {
    PasswordDialog
  },
  data() {
    return {
      user_info: {},
      role_name: "",
      passWordDialogVisible: false,
    };
  },
  created() {
    this.loadProfile();
  },
  methods: {
    async loadProfile() {
      try {
        const infoResponse = await getInfo();
        if (!infoResponse || infoResponse.err_code !== 0) {
          return;
        }

        this.user_info = infoResponse.data || {};
        this.role_name = this.user_info.role_id
          ? String(this.user_info.role_id)
          : "";

        const roleResponse = await getRoleList({ only_admin: true });
        if (roleResponse && roleResponse.err_code === 0) {
          const role = (roleResponse.rows || []).find(
            item => Number(item.role) === Number(this.user_info.role_id)
          );
          if (role) {
            this.role_name = role.name;
          }
        }
      } catch (error) {
        this.$message.error("获取个人信息失败");
      }
    },
    close() {
      this.$store
        .dispatch("layout/delView", { path: this.$route.path })
        .then(({ visitedViews }) => {
          const latestView = visitedViews.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView.fullPath);
          } else {
            this.$router.push("/dashborad");
          }
        });
    },
  },
};
</script>

<style lang="less">
.profile-container {
  .el-form {
    margin-bottom: 15px;
    .el-form-item {
      display: flex;
      .el-form-item__label {
        width: 100px;
        text-align: left;
      }
      .el-form-item__content {
        width: 260px;
        .el-input {
          width: 100%;
        }
      }
    }
  }
}
</style>
